import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Page, Card, Button, Layout, Text, Banner } from '@shopify/polaris';
import { shopifyAuth } from '../services/shopifyAuth';
import { useNavigate } from 'react-router-dom';

export const Install: React.FC = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const forceReauth = searchParams.get('force_reauth');
    if (forceReauth === 'true') {
      // Clear existing authentication
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      localStorage.removeItem('storeData');
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('storeData');
    }

    // Extract shop from URL or search params
    let extractedShop = searchParams.get('shop');
    
    if (!extractedShop) {
      // Try to extract from URL path
      const pathMatch = window.location.pathname.match(/\/store\/([^.]+)\.myshopify\.com/);
      if (pathMatch) {
        extractedShop = pathMatch[1] + '.myshopify.com';
      }
    }

    if (extractedShop) {
      // We have a shop, initiate OAuth
      initiateOAuth(extractedShop);
    } else {
      setError('No shop domain found. Please provide a valid Shopify store domain.');
    }
  }, [searchParams, navigate]);

  const initiateOAuth = async (shop: string) => {
    setIsProcessing(true);
    try {
      const authUrl = shopifyAuth.generateAuthUrl(shop);
      window.location.href = authUrl;
    } catch (err) {
      console.error('Installation error:', err);
      setError(err instanceof Error ? err.message : 'Installation failed');
      setIsProcessing(false);
    }
  };

  const handleManualInstall = () => {
    const shop = prompt('Enter your Shopify store URL (e.g., your-store.myshopify.com):');
    if (shop) {
      initiateOAuth(shop);
    }
  };

  if (error) {
    return (
      <Page>
        <Layout>
          <Layout.Section>
            <Banner tone="critical" title="Installation Error">
              <p>{error}</p>
              <Button onClick={handleManualInstall}>Try Manual Installation</Button>
            </Banner>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Card>
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <Text variant="headingLg" as="h1">
                Welcome to TranslateFlow
              </Text>
              <Text variant="bodyMd" as="p" tone="subdued">
                AI-Powered Shopify Translation App
              </Text>
              
              {isProcessing ? (
                <div style={{ marginTop: '2rem' }}>
                  <Text variant="bodyMd" as="p">
                    Redirecting to Shopify for installation...
                  </Text>
                  <Button loading>Installing...</Button>
                </div>
              ) : (
                <div style={{ marginTop: '2rem' }}>
                  <Button 
                    variant="primary"
                    onClick={handleManualInstall}
                    size="large"
                  >
                    Install TranslateFlow
                  </Button>
                </div>
              )}
              
              <div style={{ marginTop: '2rem' }}>
                              <Text variant="bodySm" as="p" tone="subdued">
                TranslateFlow will help you translate your Shopify store content 
                using advanced AI technology. Install the app to get started.
              </Text>
              </div>
            </div>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}; 